<svg
  xmlns="http://www.w3.org/2000/svg"
  xml:space="preserve"
  width="103mm"
  height="100.824mm"
  version="1.1"
  style="
    shape-rendering: geometricPrecision;
    text-rendering: geometricPrecision;
    image-rendering: optimizeQuality;
    fill-rule: evenodd;
    clip-rule: evenodd;
    margin-top: 49px;
  "
  [style]="{ width: '100%', height: 'auto' }"
  viewBox="0 0 15724.7 20100"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
>
  <defs>
    <font
      id="FontID0"
      horiz-adv-x="605"
      font-variant="normal"
      style="fill-rule: nonzero"
      font-style="normal"
      font-weight="700"
    >
      <font-face font-family="Calibri">
        <font-face-src>
          <font-face-name name="Calibri Bold" />
        </font-face-src>
      </font-face>
      <missing-glyph><path d="M0 0z" /></missing-glyph>
      <glyph
        unicode="0"
        horiz-adv-x="506"
        d="M480.015 318.501c0,-50.5047 -4.02528,-96.0093 -12.1702,-136.671 -8.17636,-40.6617 -21.5101,-75.3168 -39.844,-103.997 -18.4911,-28.6801 -42.3284,-50.662 -71.8262,-65.8197 -29.4978,-15.3464 -65.6624,-23.0196 -108.337,-23.0196 -43.3347,0 -79.1849,7.32727 -107.519,22.1705 -28.3342,14.8432 -50.8192,36.1647 -67.3292,63.9957 -16.6672,27.8311 -28.3342,61.8258 -35.0011,102.016 -6.66688,40.1585 -10.0003,85.6631 -10.0003,136.325 0,50.1588 4.18252,95.6634 12.5161,136.514 8.3336,40.8189 21.6673,75.4741 40.0013,104.154 18.4911,28.6801 42.3284,50.662 71.8262,65.8197 29.4978,15.3464 65.5052,23.0196 107.834,23.0196 43.3347,0 79.1534,-7.32727 107.676,-22.1705 28.4915,-14.8432 51.1651,-36.1647 67.6436,-63.9957 16.6672,-27.8311 28.177,-61.8258 34.6866,-102.016 6.50964,-40.1585 9.84308,-85.6631 9.84308,-136.325zm-129.029 -6.66688c0,30.0009 -0.817636,56.3225 -2.48435,79.1534 -1.66672,23.0196 -4.18252,42.8315 -7.51596,59.8446 -3.49068,16.8244 -7.83043,31.1645 -12.8306,42.8315 -5.00016,11.667 -11.1639,21.1642 -18.4911,27.9883 -7.17004,7.0128 -15.3149,12.013 -24.4976,15.0005 -9.15123,2.86173 -19.3402,4.33976 -30.5041,4.33976 -19.1515,0 -35.1583,-4.65423 -47.8317,-13.8369 -12.6734,-9.30847 -22.485,-23.1454 -30.0009,-41.8252 -7.32727,-18.4911 -12.4847,-41.5107 -15.3149,-69.1531 -3.01896,-27.6738 -4.52844,-59.8446 -4.52844,-96.5125 0,-44.8442 1.8554,-81.9837 5.34608,-111.324 3.67936,-29.4978 9.33992,-52.8319 17.0131,-70.3481 7.64175,-17.3276 17.6421,-29.4978 29.655,-36.4791 12.1702,-7.0128 26.6675,-10.5035 43.8379,-10.5035 12.6734,0 23.9945,1.98119 33.8375,6.16372 9.81163,3.99384 18.3339,10.1576 25.8184,18.1452 7.32727,8.17636 13.491,18.3339 18.3339,30.85 5.00016,12.3274 8.99399,26.6675 12.013,42.8315 3.14475,16.3213 5.31463,34.6552 6.47819,55.159 1.19501,20.3466 1.66672,43.0202 1.66672,67.6751z"
      />
      <glyph
        unicode="1"
        horiz-adv-x="506"
        d="M460.989 48.838c0,-9.18268 -0.50316,-16.8244 -1.47803,-23.1768 -1.00632,-6.32095 -2.35856,-11.5098 -4.18252,-15.1577 -1.66672,-3.8366 -3.8366,-6.50964 -6.00648,-8.01912 -2.32712,-1.66672 -5.00016,-2.48435 -7.83043,-2.48435l-349.476 0c-2.5158,0 -5.00016,0.817636 -7.35872,2.48435 -2.16988,1.50948 -4.15107,4.18252 -5.97503,8.01912 -1.8554,3.64791 -3.1762,8.83676 -4.18252,15.1577 -1.00632,6.3524 -1.50948,13.9942 -1.50948,23.1768 0,9.33992 0.345923,17.1704 1.16356,23.6485 0.849083,6.3524 2.16988,11.3526 4.02528,15.3464 1.82396,3.8366 3.8366,6.66688 6.16372,8.49083 2.16988,1.8554 4.81147,2.67304 7.6732,2.67304l117.991 0 0 410.988 -101.513 -55.9766c-7.32727,-3.52212 -13.491,-5.84924 -18.1452,-6.66688 -4.84292,-0.660398 -8.52228,0.157238 -11.3526,2.98752 -2.67304,2.83028 -4.497,7.51596 -5.50332,14.3401 -1.00632,6.82411 -1.47803,16.51 -1.47803,28.8374 0,7.83043 0.157238,14.3401 0.471713,19.3402 0.345923,5.00016 1.19501,9.30847 2.5158,12.8306 1.16356,3.64791 2.98752,6.47819 5.34608,8.83676 2.13843,2.32712 5.31463,4.65423 9.15123,7.32727l135.665 87.833c1.66672,1.3208 3.67936,2.32712 6.00648,3.14475 2.48435,0.849083 5.66056,1.50948 9.65439,2.01264 3.8366,0.50316 8.99399,0.849083 15.3464,1.00632 6.32095,0.157238 14.4973,0.157238 24.6549,0.157238 12.3274,0 22.3277,-0.157238 30.0009,-0.660398 7.6732,-0.50316 13.491,-1.3208 17.3276,-2.5158 4.02528,-1.16356 6.50964,-2.64159 7.83043,-4.65423 1.35224,-2.01264 2.01264,-4.33976 2.01264,-7.32727l0 -521.84 103.337 0c2.98752,0 5.66056,-0.817636 8.17636,-2.67304 2.48435,-1.82396 4.497,-4.65423 6.32095,-8.49083 1.82396,-3.99384 3.1762,-8.99399 3.99384,-15.3464 0.849083,-6.47819 1.16356,-14.3086 1.16356,-23.6485z"
      />
      <glyph
        unicode="2"
        horiz-adv-x="506"
        d="M466.996 52.3287c0,-9.49715 -0.314475,-17.6735 -1.16356,-24.3404 -0.817636,-6.66688 -2.16988,-11.9815 -3.67936,-16.3213 -1.66672,-4.18252 -3.80515,-7.17004 -6.32095,-8.99399 -2.67304,-1.8554 -5.66056,-2.67304 -8.83676,-2.67304l-363.502 0c-7.17004,0 -13.3338,0.660398 -18.4911,2.01264 -5.15739,1.3208 -9.49715,3.80515 -12.6734,7.48451 -3.33344,3.8366 -5.66056,9.18268 -7.17004,16.3213 -1.47803,7.17004 -2.16988,16.51 -2.16988,27.8625 0,10.818 0.50316,20.0006 1.50948,27.6424 1.00632,7.6732 2.67304,14.4973 5.34608,20.5038 2.64159,6.00648 5.97503,11.8243 10.0003,17.5163 4.15107,5.81779 9.30847,11.9815 15.9753,18.8371l109.5 116.985c21.856,22.8309 39.4981,43.4919 52.8319,62.329 13.3338,18.6798 23.8372,35.8502 31.3532,51.3538 7.48451,15.4722 12.4847,29.655 15.3149,42.6429 2.86173,13.0193 4.18252,25.5039 4.18252,37.171 0,10.6607 -1.66672,20.8497 -5.15739,30.5041 -3.33344,9.49715 -8.52228,17.8307 -15.1892,25.0008 -6.66688,7.17004 -15.0005,12.6734 -25.158,16.8244 -10.0003,3.99384 -21.8246,6.00648 -35.6615,6.00648 -19.183,0 -36.1647,-2.48435 -51.0079,-7.32727 -14.8432,-4.84292 -27.8311,-10.3462 -38.9949,-16.3527 -11.3211,-6.16372 -20.661,-11.6356 -28.177,-16.6357 -7.48451,-5.18884 -13.3338,-7.6732 -17.4848,-7.6732 -3.01896,0 -5.50332,1.00632 -7.6732,2.98752 -2.16988,1.82396 -3.8366,5.15739 -5.15739,9.68584 -1.16356,4.65423 -2.32712,10.6607 -3.1762,18.4911 -0.817636,7.6732 -1.16356,16.9817 -1.16356,27.9883 0,7.51596 0.157238,13.8369 0.660398,18.9943 0.50316,5.00016 1.35224,9.33992 2.32712,13.1765 0.849083,3.67936 2.16988,7.0128 3.8366,9.84308 1.66672,2.67304 4.497,6.00648 8.52228,10.0003 4.15107,3.8366 11.667,8.83676 22.485,14.8118 11.0066,6.16372 24.3404,12.013 40.3472,17.6735 15.9753,5.66056 33.4916,10.5035 52.8319,14.4973 19.1515,3.8366 39.1522,5.84924 60.0019,5.84924 32.9885,0 61.6372,-4.18252 86.3235,-12.5161 24.4976,-8.3336 45.0014,-19.8119 61.3227,-34.6552 16.3527,-14.8432 28.3342,-32.3281 36.3533,-52.6746 7.98767,-20.3151 11.9815,-42.1711 11.9815,-65.6624 0,-20.5038 -1.98119,-40.6617 -5.81779,-60.505 -4.02528,-20.0006 -12.1702,-41.3221 -24.4976,-64.3416 -12.3589,-22.8309 -29.8437,-48.3349 -52.3601,-76.1659 -22.485,-27.8311 -52.3287,-60.1591 -89.4997,-96.9842l-73.8074 -75.5055 249.002 0c3.33344,0 6.32095,-1.00632 8.99399,-2.98752 2.83028,-1.8554 5.15739,-4.84292 7.17004,-8.99399 1.98119,-4.02528 3.33344,-9.33992 4.30831,-16.0068 1.00632,-6.66688 1.50948,-14.686 1.50948,-23.68z"
      />
      <glyph
        unicode="3"
        horiz-adv-x="506"
        d="M464.008 184.849c0,-31.5104 -6.00648,-59.5302 -18.0194,-83.8391 -12.1702,-24.3404 -28.8374,-44.8442 -50.316,-61.3541 -21.5101,-16.4785 -47.1713,-29.1519 -77.015,-37.8314 -30.0009,-8.49083 -62.6435,-12.8306 -98.1477,-12.8306 -21.3529,0 -41.5107,1.50948 -60.505,4.68568 -18.8371,3.14475 -35.5043,6.98135 -50.0016,11.667 -14.4973,4.497 -26.3216,9.30847 -35.8502,14.3086 -9.30847,4.84292 -15.4722,8.67952 -18.4911,11.1639 -2.98752,2.67304 -5.15739,5.50332 -6.66688,8.83676 -1.3208,3.1762 -2.67304,7.0128 -3.8366,11.3526 -1.16356,4.497 -1.98119,10.0003 -2.48435,16.6672 -0.50316,6.47819 -0.660398,14.6545 -0.660398,23.9945 0,15.5036 1.3208,26.3216 3.80515,32.3281 2.67304,6.00648 6.66688,8.99399 11.8557,8.99399 3.14475,0 8.83676,-2.16988 16.8244,-6.47819 7.98767,-4.33976 18.1767,-9.02544 30.5041,-14.0256 12.3274,-5.00016 26.8247,-9.65439 43.4919,-13.9942 16.6672,-4.33976 35.5043,-6.47819 56.6684,-6.47819 17.8307,0 33.6803,2.13843 47.3285,6.32095 13.6797,4.15107 25.3467,10.1576 35.0011,17.6735 9.49715,7.64175 16.6672,16.8244 21.5101,27.6424 4.65423,10.8494 6.98135,23.0196 6.98135,36.1961 0,14.6545 -2.83028,27.6424 -8.49083,39.3094 -5.81779,11.667 -14.1514,21.6673 -25.5039,29.8437 -11.1639,8.3336 -25.3153,14.6545 -42.4856,19.1515 -17.0131,4.52844 -37.171,6.85556 -60.3478,6.85556l-54.6558 0c-4.33976,0 -7.83043,0.50316 -10.8494,1.66672 -2.83028,1.16356 -5.31463,3.49068 -7.32727,7.17004 -1.82396,3.49068 -3.33344,8.49083 -4.15107,14.8118 -0.849083,6.3524 -1.16356,14.4973 -1.16356,24.4976 0,9.49715 0.314475,17.1704 1.16356,23.1768 0.817636,6.00648 2.16988,10.6607 3.99384,13.8369 1.66672,3.33344 3.99384,5.66056 6.66688,6.82411 2.83028,1.35224 6.16372,2.01264 10.0003,2.01264l55.0017 0c18.8371,0 35.5043,2.16988 50.0016,6.66688 14.6545,4.33976 26.8247,10.6607 36.8251,18.8371 9.84308,8.14491 17.3276,17.988 22.5164,29.655 5.15739,11.5098 7.83043,24.3404 7.83043,38.4918 0,10.6922 -1.8554,21.0069 -5.34608,30.5041 -3.64791,9.68584 -8.83676,18.0194 -15.8181,25.0008 -7.0128,7.0128 -16.0068,12.6734 -27.0134,16.6672 -11.0066,4.18252 -23.9945,6.16372 -38.9949,6.16372 -16.8244,0 -32.674,-2.48435 -47.6745,-7.6732 -15.0005,-5.00016 -28.3342,-10.472 -40.1585,-16.4785 -11.8243,-6.16372 -21.8246,-11.8557 -30.1582,-17.0131 -8.3336,-5.15739 -14.3401,-7.83043 -18.3339,-7.83043 -2.5158,0 -4.84292,0.50316 -6.66688,1.66672 -2.01264,1.16356 -3.67936,3.33344 -5.00016,6.66688 -1.16356,3.33344 -2.16988,7.98767 -2.83028,14.1828 -0.691846,6.32095 -1.00632,14.3086 -1.00632,24.1517 0,8.17636 0.157238,14.8432 0.50316,20.3466 0.314475,5.31463 0.974873,9.81163 1.98119,13.491 1.00632,3.49068 2.16988,6.66688 3.67936,9.33992 1.3208,2.48435 3.8366,5.31463 6.98135,8.49083 3.33344,3.1762 10.0003,7.6732 20.0006,13.8369 10.189,6.16372 22.8309,12.1702 38.0201,17.988 15.3149,5.84924 32.9885,10.6607 52.9891,14.8432 20.0006,3.99384 41.668,6.00648 65.1593,6.00648 30.5041,0 57.5175,-3.67936 81.1661,-10.8494 23.5228,-7.17004 43.3347,-17.4848 59.4987,-31.0073 16.0068,-13.491 28.3342,-30.1582 36.5106,-49.8129 8.3336,-19.8434 12.5161,-42.0139 12.5161,-66.826 0,-19.183 -2.5158,-37.171 -7.35872,-53.6809 -4.81147,-16.6672 -11.9815,-31.5104 -21.4787,-44.4983 -9.33992,-13.1765 -21.1642,-24.1517 -35.347,-33.3344 -14.1514,-9.15123 -30.5041,-16.0068 -48.9953,-20.5038l0 -1.50948c22.1705,-2.64159 42.0139,-8.14491 59.656,-16.8244 17.5163,-8.49083 32.5167,-19.3402 44.6869,-32.3281 12.1702,-12.9878 21.4787,-27.6738 27.9883,-44.1523 6.50964,-16.3527 9.84308,-34.0262 9.84308,-52.8319z"
      />
      <glyph
        unicode="4"
        horiz-adv-x="506"
        d="M486.996 181.987c0,-16.6672 -1.66672,-29.3091 -5.15739,-37.9886 -3.33344,-8.67952 -8.01912,-12.9878 -13.8369,-12.9878l-56.0081 0 0 -114.5c0,-3.1762 -1.00632,-6.00648 -2.98752,-8.52228 -1.8554,-2.48435 -5.34608,-4.497 -10.1576,-6.16372 -5.00016,-1.47803 -11.3526,-2.83028 -19.183,-3.64791 -7.83043,-0.849083 -17.988,-1.16356 -30.3469,-1.16356 -11.8243,0 -21.6673,0.314475 -29.655,1.16356 -7.98767,0.817636 -14.4973,2.16988 -19.1515,3.64791 -4.68568,1.66672 -8.01912,3.67936 -9.84308,6.16372 -1.82396,2.5158 -2.67304,5.34608 -2.67304,8.52228l0 114.5 -241.674 0c-4.497,0 -8.64807,0.50316 -12.1702,1.66672 -3.64791,1.16356 -6.66688,3.8366 -9.15123,7.83043 -2.32712,4.15107 -4.18252,10.0003 -5.34608,17.6735 -1.16356,7.64175 -1.66672,17.8307 -1.66672,30.6613 0,10.5035 0.188685,19.4975 0.691846,27.1707 0.471713,7.64175 1.3208,14.6545 2.48435,20.8183 1.16356,6.16372 2.83028,12.013 4.84292,17.6735 2.16988,5.50332 4.81147,11.3211 8.14491,17.4848l196.17 346.017c1.66672,2.83028 4.497,5.31463 8.3336,7.48451 4.02528,2.16988 9.33992,3.8366 16.3527,5.34608 6.98135,1.50948 16.0068,2.48435 26.6675,3.1762 10.6607,0.660398 23.8372,0.974873 38.9949,0.974873 16.6672,0 31.0073,-0.314475 42.6743,-1.16356 11.8243,-0.817636 21.3214,-2.16988 28.3342,-3.99384 6.98135,-1.66672 12.1387,-3.99384 15.4722,-6.50964 3.1762,-2.64159 4.84292,-5.66056 4.84292,-9.30847l0 -380.012 56.0081 0c5.15739,0 9.65439,-3.99384 13.3338,-12.013 3.8366,-7.98767 5.66056,-21.3214 5.66056,-40.0013zm-199 342.023l-1.00632 0 -165.98 -290.009 166.986 0 0 290.009z"
      />
      <glyph
        unicode="5"
        horiz-adv-x="506"
        d="M460.989 205.321c0,-34.152 -5.97503,-64.6561 -17.8307,-91.4809 -11.8243,-26.8247 -28.6487,-49.4984 -50.316,-68.021 -21.6673,-18.3339 -47.6745,-32.3281 -78.0213,-42.1397 -30.4727,-9.84308 -64.153,-14.686 -101.324,-14.686 -19.4975,0 -38.1773,1.16356 -55.6621,3.67936 -17.6735,2.48435 -33.3344,5.66056 -47.3285,9.33992 -13.9942,3.80515 -25.5039,7.48451 -34.4979,11.3211 -8.83676,3.8366 -14.8432,6.82411 -17.5163,9.33992 -2.83028,2.48435 -4.81147,5.15739 -6.16372,7.98767 -1.3208,3.01896 -2.32712,6.50964 -3.1762,10.5035 -0.817636,4.18252 -1.3208,9.33992 -1.66672,15.5036 -0.314475,6.16372 -0.471713,13.491 -0.471713,22.0133 0,9.15123 0.314475,16.8244 0.974873,23.1454 0.691846,6.3524 1.66672,11.5098 3.1762,15.3464 1.50948,3.99384 3.1762,6.82411 5.15739,8.3336 1.8554,1.66672 4.18252,2.48435 6.85556,2.48435 3.14475,0 8.14491,-1.82396 14.8118,-5.66056 6.66688,-3.67936 15.5036,-7.83043 26.353,-12.3274 10.9752,-4.497 24.3089,-8.67952 39.8126,-12.3274 15.6923,-3.8366 34.4979,-5.66056 56.1653,-5.66056 19.0258,0 36.1647,1.98119 51.6683,5.81779 15.5036,3.99384 28.5229,10.1576 39.3409,18.8371 10.6607,8.64807 18.9943,19.3402 24.8435,32.4853 5.81779,13.0193 8.83676,28.5229 8.83676,46.8568 0,15.4722 -2.5158,29.4978 -7.35872,41.668 -4.81147,12.1387 -12.4847,22.485 -22.9881,30.9758 -10.3148,8.52228 -23.8372,14.8432 -40.5044,19.0258 -16.6672,4.15107 -36.8251,6.32095 -60.505,6.32095 -18.9943,0 -36.1647,-1.00632 -51.4796,-2.98752 -15.5036,-1.8554 -30.1896,-2.86173 -43.8379,-2.86173 -9.33992,0 -16.164,2.35856 -20.1579,7.0128 -4.18252,4.84292 -6.16372,13.491 -6.16372,26.1643l0 274.16c0,13.0193 2.48435,22.3277 7.48451,28.0197 5.15739,5.66056 13.1765,8.49083 24.1517,8.49083l299.349 0c2.83028,0 5.66056,-1.00632 8.3336,-2.98752 2.48435,-1.8554 4.84292,-5.00016 6.50964,-9.18268 1.82396,-4.33976 3.14475,-9.84308 3.99384,-17.0131 0.817636,-6.98135 1.16356,-15.3149 1.16356,-25.158 0,-19.4975 -1.66672,-33.6489 -5.15739,-42.4856 -3.33344,-8.83676 -8.3336,-13.1765 -14.8432,-13.1765l-225.007 0 0 -135.004c11.3526,1.35224 22.6737,2.16988 33.9948,2.5158 11.1639,0.314475 23.0196,0.50316 35.347,0.50316 34.3407,0 64.6561,-4.02528 91.1664,-12.013 26.6675,-7.98767 48.9953,-19.6547 66.9832,-35.1583 18.1767,-15.5036 31.8563,-34.6866 41.3535,-57.6748 9.49715,-22.8309 14.1514,-49.4984 14.1514,-79.8453z"
      />
      <glyph
        unicode="6"
        horiz-adv-x="506"
        d="M476.996 211.013c0,-31.8563 -4.84292,-61.3541 -14.6545,-88.5248 -9.84308,-27.1392 -24.1832,-50.662 -43.0202,-70.3167 -18.8371,-19.6862 -42.1397,-35.1583 -69.8135,-46.3537 -27.8311,-11.1639 -59.6874,-16.8244 -95.8521,-16.8244 -29.3091,0 -55.0017,3.33344 -76.8263,10.0003 -21.8246,6.66688 -40.6617,16.3527 -56.6684,28.8374 -16.0068,12.5161 -28.9946,27.8311 -39.1522,45.6618 -10.0003,17.8307 -18.1767,38.1773 -24.1832,60.505 -6.00648,22.5164 -10.1576,47.0141 -12.3274,73.3356 -2.32712,26.3216 -3.49068,54.3413 -3.49068,83.9964 0,24.6549 1.16356,50.662 3.64791,77.6754 2.5158,26.982 7.17004,53.4922 14.1828,79.6566 6.98135,26.0071 16.8244,50.8507 29.4978,74.4992 12.6734,23.4913 29.1519,44.1838 49.1525,62.0145 20.0006,17.6421 44.1838,31.8249 72.6752,42.1711 28.4915,10.472 62.329,15.6609 101.324,15.6609 12.3589,0 24.8435,-0.660398 37.3597,-2.16988 12.4847,-1.50948 24.1517,-3.33344 35.0011,-5.66056 10.6607,-2.16988 19.8119,-4.84292 27.3279,-7.83043 7.48451,-2.86173 12.3274,-5.34608 14.8118,-7.51596 2.5158,-2.16988 4.33976,-4.497 5.692,-7.0128 1.3208,-2.64159 2.32712,-5.47187 3.14475,-8.64807 0.849083,-3.01896 1.35224,-6.82411 1.66672,-11.3211 0.345923,-4.68568 0.50316,-10.189 0.50316,-16.6672 0,-10.0003 -0.157238,-18.3339 -0.660398,-25.0008 -0.50316,-6.66688 -1.50948,-12.013 -2.83028,-15.6923 -1.16356,-3.8366 -3.01896,-6.47819 -5.34608,-7.98767 -2.16988,-1.66672 -5.00016,-2.5158 -8.3336,-2.5158 -3.8366,0 -8.83676,1.00632 -15.0005,3.1762 -6.16372,2.16988 -13.6482,4.497 -22.485,7.0128 -8.83676,2.67304 -19.183,5.00016 -31.0073,6.82411 -11.8243,2.01264 -25.6612,2.98752 -41.3221,2.98752 -26.353,0 -48.5235,-4.81147 -66.8574,-14.6545 -18.1452,-9.84308 -32.9885,-23.1768 -44.3096,-40.0013 -11.5098,-16.8244 -19.8434,-36.3219 -25.0008,-58.4924 -5.18884,-22.1705 -8.01912,-45.6618 -8.3336,-70.5054 7.17004,4.65423 15.5036,9.18268 24.8121,13.6797 9.18268,4.65423 19.3402,8.49083 30.1896,11.8243 10.9752,3.1762 22.8309,5.81779 35.5043,7.98767 12.6419,2.16988 26.3216,3.1762 40.6617,3.1762 31.8249,0 59.1528,-4.33976 81.9837,-13.1765 22.8309,-8.83676 41.5107,-21.3214 56.0081,-37.6427 14.4973,-16.1955 25.158,-35.8502 32.0136,-59.027 6.82411,-22.9881 10.3148,-48.8066 10.3148,-77.1408zm-126.01 -12.1702c0,16.4785 -1.47803,30.9758 -4.30831,43.4919 -3.01896,12.4847 -7.6732,22.9881 -14.3401,31.6677 -6.50964,8.49083 -15.1577,15.0005 -25.8499,19.4975 -10.818,4.33976 -23.8058,6.50964 -39.1522,6.50964 -9.18268,0 -18.1767,-0.849083 -27.0134,-2.5158 -8.64807,-1.47803 -17.3276,-3.8366 -25.8184,-6.66688 -8.49083,-2.98752 -16.6672,-6.47819 -24.4976,-10.5035 -7.83043,-3.99384 -15.1577,-8.3336 -22.0133,-12.8306 0,-34.8124 2.01264,-63.6498 5.84924,-86.8266 3.99384,-23.1768 9.65439,-41.668 17.3276,-55.159 7.6732,-13.6797 17.3276,-23.3341 28.9946,-28.9946 11.5098,-5.692 25.0008,-8.52228 40.3472,-8.52228 15.0005,0 28.1455,2.83028 39.3094,8.3336 11.3526,5.50332 20.6925,13.1765 28.177,23.3341 7.51596,10.0003 13.1765,21.6673 17.1704,35.1898 3.8366,13.491 5.81779,28.1455 5.81779,43.9951z"
      />
      <glyph
        unicode="7"
        horiz-adv-x="506"
        d="M466.996 578.006c0,-9.49715 -0.314475,-17.6735 -1.00632,-24.6863 -0.660398,-6.98135 -1.47803,-13.491 -2.64159,-19.4975 -1.19501,-5.97503 -2.67304,-11.667 -4.68568,-16.9817 -1.82396,-5.34608 -4.15107,-11.1639 -6.82411,-17.3276l-207.837 -482.499c-2.01264,-4.18252 -4.497,-7.6732 -7.51596,-10.189 -3.14475,-2.67304 -7.48451,-4.65423 -12.9878,-6.16372 -5.50332,-1.47803 -12.6734,-2.48435 -21.1642,-2.98752 -8.67952,-0.50316 -19.3402,-0.660398 -32.0136,-0.660398 -17.1389,0 -30.8186,0.50316 -40.9761,1.66672 -10.0003,1.16356 -17.5163,2.98752 -22.1705,5.47187 -4.68568,2.35856 -7.32727,5.50332 -7.51596,9.18268 -0.314475,3.8366 0.660398,8.49083 3.33344,13.9942l222.994 493.663 -265.48 0c-6.82411,0 -12.013,4.497 -15.3464,13.3338 -3.49068,8.99399 -5.15739,23.1768 -5.15739,42.6743 0,9.65439 0.50316,18.1767 1.50948,25.0008 0.974873,7.0128 2.32712,12.8306 4.15107,17.3276 1.82396,4.497 3.8366,7.83043 6.3524,9.68584 2.48435,1.98119 5.31463,2.98752 8.49083,2.98752l375.672 0c5.97503,0 10.818,-0.50316 14.6545,-1.66672 3.99384,-1.16356 7.0128,-3.67936 9.33992,-7.51596 2.32712,-3.99384 3.99384,-9.49715 5.15739,-16.6672 1.16356,-7.13859 1.66672,-16.4785 1.66672,-28.1455z"
      />
      <glyph
        unicode="8"
        horiz-adv-x="506"
        d="M476.996 169.502c0,-28.4915 -5.00016,-54.1841 -14.8432,-76.5118 -10.0003,-22.485 -24.6549,-41.4793 -43.9951,-56.8257 -19.3088,-15.5036 -43.4919,-27.1707 -72.1721,-35.1583 -28.6487,-8.01912 -61.6372,-12.013 -99.1541,-12.013 -35.6615,0 -67.1719,3.52212 -94.1539,10.6607 -27.0134,7.17004 -49.6871,17.6735 -68.021,31.5104 -18.1452,13.8369 -31.8249,31.0073 -40.9761,51.3224 -9.18268,20.3466 -13.6797,43.6806 -13.6797,70.0022 0,17.8307 2.67304,34.6866 7.98767,50.5047 5.50332,15.8496 13.3338,30.5041 24.0259,43.9951 10.472,13.5224 23.8058,26.1643 39.4981,38.0201 15.8181,11.8243 33.9948,23.1454 54.4986,33.9948 -16.6672,8.99399 -31.6677,18.8371 -45.0014,29.4978 -13.3338,10.5035 -24.6863,22.0133 -34.1835,34.6552 -9.49715,12.5161 -16.6672,26.1643 -21.4787,41.1648 -4.84292,15.0005 -7.35872,31.3532 -7.35872,48.838 0,25.3467 4.497,48.3349 13.5224,68.9959 8.83676,20.6925 22.3277,38.6805 40.0013,53.6809 17.8307,15.1577 40.0013,26.8247 66.6688,35.0011 26.8247,8.17636 57.6433,12.1702 92.8331,12.1702 35.0011,0 64.8134,-3.67936 89.8141,-11.1639 24.8435,-7.51596 45.3473,-18.1767 61.3227,-31.8563 15.8496,-13.6482 27.6738,-30.0009 35.347,-48.9953 7.6732,-18.9943 11.5098,-40.1585 11.5098,-63.1466 0,-15.3464 -2.5158,-30.1896 -7.51596,-44.6869 -5.15739,-14.4973 -12.1702,-28.3342 -21.3214,-41.3221 -9.18268,-12.9878 -20.3466,-25.158 -33.6803,-36.8251 -13.3338,-11.5098 -28.4915,-22.0133 -45.5046,-31.5104 19.8434,-10.3462 37.6741,-21.3214 53.1778,-33.1771 15.6609,-11.667 28.8374,-24.3089 39.6553,-37.8314 10.6922,-13.491 19.0258,-27.8311 24.6863,-43.146 5.66056,-15.3464 8.49083,-31.8563 8.49083,-49.8443zm-141.986 306.488c0,11.3526 -1.66672,21.5101 -4.84292,30.6613 -3.33344,9.02544 -8.3336,16.8559 -15.3464,23.1768 -6.98135,6.3524 -15.6609,11.0066 -25.8184,14.3401 -10.1576,3.1762 -22.3277,4.84292 -36.1647,4.84292 -27.3279,0 -47.5172,-6.3524 -60.851,-18.8371 -13.3338,-12.5161 -20.0006,-29.6865 -20.0006,-51.8255 0,-10.3462 1.66672,-20.0006 5.18884,-28.6801 3.33344,-8.83676 8.64807,-17.1704 15.8181,-24.8435 7.0128,-7.83043 16.3527,-15.5036 27.6738,-22.9881 11.3211,-7.51596 24.8435,-15.3464 40.3472,-23.8372 23.6485,13.9942 41.9825,28.8374 54.813,44.8442 12.8306,15.8181 19.183,33.6489 19.183,53.1463zm15.0005 -314.978c0,11.9815 -2.01264,22.9881 -6.16372,32.8312 -4.02528,10.0003 -10.3462,19.3088 -19.0258,27.9883 -8.64807,8.83676 -19.4975,17.3276 -32.6425,25.3467 -13.0193,8.14491 -28.177,16.4785 -45.5046,24.8121 -15.0005,-7.98767 -28.3342,-16.164 -39.6868,-24.3089 -11.4783,-8.01912 -20.9755,-16.6672 -28.4915,-25.5039 -7.48451,-9.02544 -13.1765,-18.3339 -16.8244,-28.3342 -3.8366,-9.84308 -5.66056,-20.5038 -5.66056,-31.8563 0,-25.3153 8.14491,-44.6555 24.6549,-57.9892 16.51,-13.3338 41.1648,-20.0006 73.8388,-20.0006 31.9821,0 55.8194,6.82411 71.6689,20.5038 15.8181,13.6797 23.8372,32.4853 23.8372,56.5112z"
      />
      <glyph
        unicode="9"
        horiz-adv-x="506"
        d="M468.002 344.822c0,-25.6612 -1.3208,-52.3287 -3.8366,-79.8138 -2.67304,-27.5166 -7.6732,-54.4986 -15.0005,-80.8516 -7.32727,-26.3216 -17.3276,-51.3224 -30.3469,-75.1596 -12.8306,-23.6485 -29.4978,-44.4983 -49.8129,-62.1718 -20.3466,-17.6735 -45.1587,-31.8249 -74.342,-42.1711 -29.1519,-10.472 -63.4926,-15.6609 -103.337,-15.6609 -13.9942,0 -27.8311,1.00632 -41.8252,3.01896 -13.8369,1.82396 -26.3216,4.30831 -37.8314,7.17004 -11.3526,2.98752 -21.0069,6.16372 -28.9946,9.30847 -8.01912,3.33344 -13.8369,6.66688 -17.3276,10.0003 -3.67936,3.52212 -6.3524,8.3336 -7.86188,14.8432 -1.66672,6.50964 -2.48435,15.6609 -2.48435,27.3279 0,10.8494 0.157238,19.3402 0.660398,25.8499 0.50316,6.47819 1.50948,11.667 3.01896,15.1577 1.47803,3.64791 3.33344,6.00648 5.31463,7.17004 2.16988,1.00632 4.68568,1.66672 7.6732,1.66672 3.8366,0 9.49715,-1.16356 16.6672,-3.52212 7.17004,-2.13843 15.8181,-4.81147 26.1643,-7.83043 10.3462,-2.83028 22.0133,-5.47187 35.0011,-7.64175 12.9878,-2.35856 27.6738,-3.52212 43.6806,-3.52212 27.3279,0 50.4733,4.84292 69.499,14.686 18.8056,9.81163 34.152,22.9881 45.9763,39.6553 11.8557,16.6672 20.3466,36.0074 26.0071,57.832 5.50332,21.8246 8.67952,44.8442 9.33992,68.9959 -15.0005,-9.49715 -33.1771,-17.6735 -54.3413,-24.6549 -21.1642,-7.0128 -45.5046,-10.5035 -72.8325,-10.5035 -33.6489,0 -62.1718,4.33976 -85.5058,13.1765 -23.4913,8.83676 -42.6429,21.4787 -57.3288,37.9886 -14.6545,16.6672 -25.3153,36.6678 -31.9821,60.505 -6.66688,23.6485 -10.0003,50.5047 -10.0003,80.317 0,31.6677 4.65423,60.6937 14.1514,87.1726 9.49715,26.353 23.4913,49.3412 42.0139,68.6814 18.4911,19.3088 41.668,34.3093 69.3104,45.0014 27.6738,10.818 59.6874,16.164 96.1665,16.164 29.3405,0 55.0017,-3.33344 76.8578,-10.189 21.9818,-6.82411 40.8189,-16.6672 56.6684,-29.3091 15.8181,-12.6734 28.9946,-28.177 39.4981,-46.165 10.6607,-18.0194 18.9943,-38.1773 25.0008,-60.3478 5.97503,-21.9818 10.1576,-46.0077 12.6419,-71.6689 2.5158,-25.6612 3.67936,-52.4859 3.67936,-80.5057zm-127.017 18.1767c0,34.6552 -1.98119,63.6812 -5.81779,86.8266 -3.99384,23.3341 -9.84308,42.0139 -17.6735,55.8508 -7.83043,13.8369 -17.6735,23.8372 -29.3405,29.655 -11.667,5.84924 -25.4725,8.67952 -41.1648,8.67952 -15.3149,0 -28.4915,-2.67304 -39.4981,-8.01912 -11.1639,-5.31463 -20.3151,-12.8306 -27.6424,-22.485 -7.35872,-9.84308 -12.862,-21.1642 -16.51,-34.4979 -3.49068,-13.3338 -5.34608,-27.8311 -5.34608,-43.6806 0,-17.1704 1.50948,-32.3281 4.68568,-45.3159 2.98752,-13.1765 7.98767,-24.0259 14.6545,-32.5167 6.66688,-8.64807 15.3464,-15.0005 26.1643,-19.1515 10.8494,-4.18252 23.8372,-6.3524 39.1836,-6.3524 18.8056,0 36.8251,2.83028 53.4922,8.52228 16.8244,5.66056 31.8249,13.1451 44.8127,22.485z"
      />
      <glyph
        unicode="M"
        horiz-adv-x="873"
        d="M804.994 17.4848c0,-3.14475 -0.817636,-6.16372 -2.67304,-8.80531 -1.82396,-2.5158 -5.15739,-4.68568 -9.81163,-6.3524 -4.68568,-1.50948 -11.0066,-2.83028 -18.8371,-3.8366 -7.83043,-0.974873 -17.8307,-1.47803 -29.8437,-1.47803 -11.8243,0 -21.6673,0.50316 -29.4978,1.47803 -7.83043,1.00632 -13.9942,2.32712 -18.6484,3.8366 -4.52844,1.66672 -7.86188,3.8366 -9.68584,6.3524 -1.98119,2.64159 -2.98752,5.66056 -2.98752,8.80531l0 514.513 -1.00632 0 -182.49 -514.01c-1.35224,-4.15107 -3.33344,-7.64175 -6.3524,-10.5035 -2.98752,-2.83028 -6.82411,-5.00016 -11.9815,-6.66688 -5.00016,-1.47803 -11.5098,-2.64159 -19.183,-3.14475 -7.83043,-0.50316 -17.3276,-0.660398 -28.3342,-0.660398 -11.1639,0 -20.5038,0.314475 -28.3342,1.16356 -7.83043,0.817636 -14.3401,2.16988 -19.3402,3.99384 -5.00016,1.82396 -8.99399,3.99384 -11.9815,6.50964 -2.83028,2.64159 -4.84292,5.81779 -5.84924,9.30847l-176.169 514.01 -0.974873 0 0 -514.513c0,-3.14475 -0.849083,-6.16372 -2.67304,-8.80531 -1.82396,-2.5158 -5.15739,-4.68568 -10.0003,-6.3524 -5.00016,-1.50948 -11.3526,-2.83028 -18.9943,-3.8366 -7.6732,-0.974873 -17.5163,-1.47803 -29.4978,-1.47803 -11.8557,0 -21.6673,0.50316 -29.5292,1.47803 -7.83043,1.00632 -14.1514,2.32712 -18.8056,3.8366 -4.68568,1.66672 -8.01912,3.8366 -9.84308,6.3524 -1.82396,2.64159 -2.67304,5.66056 -2.67304,8.80531l0 563.194c0,16.6672 4.33976,29.3091 13.1765,38.1459 8.83676,8.83676 20.5038,13.1765 35.3156,13.1765l83.9964 0c15.0005,0 28.0197,-1.16356 38.6805,-3.67936 10.8494,-2.48435 20.1579,-6.47819 27.9883,-12.1702 7.6732,-5.66056 14.3401,-13.1451 19.5289,-22.485 5.15739,-9.33992 9.81163,-20.8183 13.6482,-34.4979l136.168 -376.49 2.01264 0 140.979 375.641c4.18252,13.6797 8.83676,25.1895 13.8369,34.6866 5.18884,9.33992 11.0066,16.9817 17.6735,22.8309 6.66688,5.81779 14.6545,10.0003 23.68,12.4847 9.15123,2.5158 19.8119,3.67936 31.8249,3.67936l86.6694 0c8.83676,0 16.3213,-1.16356 22.6737,-3.49068 6.32095,-2.16988 11.667,-5.50332 15.6609,-10.0003 4.15107,-4.33976 7.17004,-9.68584 9.30847,-16.0068 2.16988,-6.32095 3.1762,-13.6797 3.1762,-21.8246l0 -563.194z"
      />
      <glyph
        unicode="e"
        horiz-adv-x="503"
        d="M464.008 246.989c0,-15.0005 -3.33344,-25.9757 -10.0003,-33.1457 -6.66688,-7.17004 -15.8496,-10.8494 -27.6738,-10.8494l-265.323 0c0,-18.4911 2.16988,-35.1583 6.66688,-50.316 4.30831,-15.0005 11.3211,-27.8311 20.8183,-38.3345 9.68584,-10.5035 22.0133,-18.5226 37.171,-23.9945 15.1577,-5.50332 33.1771,-8.3336 54.3413,-8.3336 21.4787,0 40.3157,1.47803 56.6684,4.65423 16.164,3.1762 30.3154,6.50964 42.1711,10.3462 11.8243,3.80515 21.6359,7.13859 29.4978,10.3148 7.83043,3.1762 14.1514,4.65423 18.9943,4.65423 2.98752,0 5.50332,-0.471713 7.32727,-1.66672 2.01264,-1.16356 3.67936,-3.14475 5.00016,-6.16372 1.16356,-2.83028 2.16988,-6.98135 2.67304,-12.3274 0.50316,-5.31463 0.660398,-12.1702 0.660398,-20.1579 0,-7.17004 -0.157238,-13.3338 -0.50316,-18.3339 -0.345923,-5.00016 -0.817636,-9.33992 -1.50948,-12.8306 -0.660398,-3.67936 -1.47803,-6.66688 -2.83028,-8.99399 -1.3208,-2.5158 -2.98752,-4.84292 -5.15739,-7.17004 -2.16988,-2.16988 -7.83043,-5.34608 -17.3276,-9.33992 -9.49715,-3.99384 -21.5101,-7.83043 -36.1647,-11.667 -14.686,-3.8366 -31.3532,-7.17004 -50.1903,-10.0003 -18.8056,-2.83028 -38.9949,-4.33976 -60.4736,-4.33976 -38.8377,0 -72.6752,4.84292 -101.859,14.686 -28.9946,9.65439 -53.335,24.4976 -72.9897,44.3096 -19.4975,19.8434 -33.9948,45.0014 -43.6492,75.191 -9.5286,30.3154 -14.3401,65.8197 -14.3401,106.481 0,38.6805 5.00016,73.4929 15.1577,104.657 10.0003,31.0073 24.6549,57.3603 43.9951,79.0276 19.183,21.6673 42.5171,38.1459 70.0022,49.4984 27.6738,11.4783 58.6811,17.1704 93.179,17.1704 36.4791,0 67.6436,-5.34608 93.4935,-16.1955 26.0071,-10.6607 47.1713,-25.6612 63.8385,-44.6555 16.4785,-18.9943 28.8374,-41.668 36.6678,-67.6751 7.83043,-25.9757 11.667,-54.3099 11.667,-85.0027l0 -19.4975zm-118.997 35.0011c0.974873,34.4979 -6.00648,61.6686 -20.8497,81.3548 -14.8432,19.8119 -37.6741,29.655 -68.65,29.655 -15.6923,0 -29.3405,-2.98752 -40.8503,-8.83676 -11.667,-5.81779 -21.3214,-13.6482 -28.9946,-23.6485 -7.6732,-10.0003 -13.491,-21.6673 -17.4848,-35.1898 -4.18252,-13.6482 -6.50964,-27.9883 -7.17004,-43.3347l183.999 0z"
      />
      <glyph
        unicode="i"
        horiz-adv-x="245"
        d="M185.006 16.51c0,-3.1762 -1.00632,-6.00648 -3.01896,-8.52228 -1.82396,-2.48435 -5.15739,-4.497 -10.0003,-6.16372 -4.65423,-1.47803 -10.9752,-2.83028 -18.6484,-3.64791 -7.83043,-0.849083 -17.8307,-1.16356 -29.8437,-1.16356 -11.9815,0 -21.9818,0.314475 -29.8123,1.16356 -7.6732,0.817636 -14.0256,2.16988 -18.6798,3.64791 -4.84292,1.66672 -8.17636,3.67936 -10.0003,6.16372 -2.01264,2.5158 -2.98752,5.34608 -2.98752,8.52228l0 434.982c0,3.1762 0.974873,6.00648 2.98752,8.52228 1.82396,2.48435 5.15739,4.65423 10.0003,6.32095 4.65423,1.82396 11.0066,3.1762 18.6798,4.15107 7.83043,1.00632 17.8307,1.50948 29.8123,1.50948 12.013,0 22.0133,-0.50316 29.8437,-1.50948 7.6732,-0.974873 13.9942,-2.32712 18.6484,-4.15107 4.84292,-1.66672 8.17636,-3.8366 10.0003,-6.32095 2.01264,-2.5158 3.01896,-5.34608 3.01896,-8.52228l0 -434.982zm10.0003 583.981c0,-24.8121 -5.00016,-41.8252 -15.1577,-51.3224 -10.189,-9.49715 -28.8374,-14.1828 -56.354,-14.1828 -27.6738,0 -46.4794,4.52844 -56.0081,13.6797 -9.65439,9.18268 -14.4973,25.6612 -14.4973,49.3412 0,24.8121 5.00016,41.9825 15.0005,51.6683 9.84308,9.49715 28.6801,14.3401 56.5112,14.3401 27.3279,0 46.0077,-4.68568 55.8194,-14.0256 9.84308,-9.15123 14.686,-25.6612 14.686,-49.4984z"
      />
      <glyph
        unicode="k"
        horiz-adv-x="480"
        d="M466.996 16.0068c0,-3.1762 -0.817636,-6.00648 -2.67304,-8.52228 -1.82396,-2.48435 -5.00016,-4.30831 -9.81163,-5.81779 -4.68568,-1.50948 -11.1639,-2.67304 -19.3402,-3.49068 -8.17636,-0.849083 -18.6798,-1.16356 -31.8249,-1.16356 -13.3338,0 -24.1832,0.314475 -32.5167,0.974873 -8.3336,0.691846 -15.1577,1.66672 -20.5038,3.1762 -5.31463,1.50948 -9.49715,3.49068 -12.4847,6.16372 -3.01896,2.5158 -5.50332,6.00648 -7.83043,10.1576l-145.005 229.693 0 -230.668c0,-3.1762 -1.00632,-6.00648 -3.01896,-8.52228 -1.82396,-2.48435 -5.15739,-4.497 -10.0003,-6.16372 -4.65423,-1.47803 -10.9752,-2.83028 -18.6484,-3.64791 -7.83043,-0.849083 -17.8307,-1.16356 -29.8437,-1.16356 -11.9815,0 -21.9818,0.314475 -29.8123,1.16356 -7.6732,0.817636 -14.0256,2.16988 -18.6798,3.64791 -4.84292,1.66672 -8.17636,3.67936 -10.0003,6.16372 -2.01264,2.5158 -2.98752,5.34608 -2.98752,8.52228l0 642.504c0,3.33344 0.974873,6.16372 2.98752,8.80531 1.82396,2.5158 5.15739,4.84292 10.0003,6.50964 4.65423,1.82396 11.0066,3.1762 18.6798,4.18252 7.83043,0.974873 17.8307,1.47803 29.8123,1.47803 12.013,0 22.0133,-0.50316 29.8437,-1.47803 7.6732,-1.00632 13.9942,-2.35856 18.6484,-4.18252 4.84292,-1.66672 8.17636,-3.99384 10.0003,-6.50964 2.01264,-2.64159 3.01896,-5.47187 3.01896,-8.80531l0 -382.528 128.998 173.527c2.67304,3.99384 5.50332,7.32727 8.83676,10.3148 3.14475,2.83028 7.48451,5.15739 12.8306,6.82411 5.31463,1.50948 11.9815,2.86173 20.0006,3.67936 7.98767,0.849083 18.1767,1.16356 30.5041,1.16356 11.9815,0 22.1705,-0.314475 30.5041,-1.16356 8.14491,-0.817636 14.8118,-2.16988 20.0006,-3.67936 5.00016,-1.66672 8.49083,-3.64791 10.3148,-6.16372 2.01264,-2.48435 3.01896,-5.50332 3.01896,-8.99399 0,-4.84292 -1.19501,-10.1576 -3.67936,-15.6609 -2.5158,-5.50332 -6.16372,-11.3211 -11.0066,-17.6735l-127.331 -144.659 147.835 -228.183c3.8366,-6.47819 6.66688,-12.1387 8.49083,-16.8244 1.8554,-4.65423 2.67304,-8.99399 2.67304,-12.9878z"
      />
    </font>
    <style type="text/css">
      @font-face {
        font-family: 'Calibri';
        font-variant: normal;
        font-style: normal;
        font-weight: bold;
        src: url('#FontID0') format(svg);
      }
      .str0 {
        stroke: #2b2a29;
        stroke-width: 20;
        stroke-miterlimit: 22.9256;
      }
      .str1 {
        stroke: #2b2a29;
        stroke-width: 20;
        stroke-miterlimit: 22.9256;
      }
      .fil0 {
        fill: none;
      }
      .fil2 {
        fill: #fefefe;
      }
      .fil4 {
        fill: #2b2a29;
      }
      .fil5 {
        fill: #c7c9c6;
      }
      .fil7 {
        fill: #c7c9c6;
      }
      .fil6 {
        fill: #cdd2cb;
      }
      .fil3 {
        fill: #cdd2cb;
      }
      .fil1 {
        fill: #fefefe;
        fill-rule: nonzero;
      }
      .fnt0 {
        font-weight: bold;
        font-size: 317.99px;
        font-family: 'Calibri';
      }
    </style>
  </defs>
  <g id="Layer_x0020_1">
    <metadata id="CorelCorpID_0Corel-Layer" />
    <path
      class="fil0 str0"
      d="M7854.48 22.73c4288.65,0 7774.88,441.74 7860.34,990.82l2.04 0 0 18020.63c0,558.62 -3520.1,1011.45 -7862.37,1011.45 -4342.27,0 -7862.37,-452.83 -7862.37,-1011.45l-0.01 0 0 -18000.01 0 -20.62 2.03 0c85.46,-549.08 3571.69,-990.82 7860.34,-990.82z"
    />
    <line class="fil0 str0" x1="14370.78" y1="508.95" x2="14372.1" y2="19568.91" />
    <line class="fil0 str0" x1="1349.85" y1="506.75" x2="1336.63" y2="19592.85" />
    <path
      class="fil0 str0"
      d="M4509.87 2621.81l6818.1 0 0 16870.05c-1047.87,64.62 -2227.32,100.99 -3474.92,100.99 -1195.58,0 -2328.57,-33.39 -3343.18,-93.05l0 -16877.99z"
    />
    <g id="Logo">
      <path
        class="fil1 str1"
        d="M8483.29 18572.35l-110.53 282.15 -18.48 47.66 -42.19 -107.7 -86.91 -222.11 -73.29 0 133.34 317.11 20.87 50.07 5.99 13.97 8.55 20.71c-7.74,26.27 -20.53,41.14 -21.71,42.41 -1,0.86 -1.65,1.5 -2.29,2.75 0,0 -0.25,0.11 -0.25,0.29 -11.16,14.16 -23.41,23.23 -35.28,26.76 -8.01,2.43 -16.35,2.81 -25.33,0.49 -10.44,-2.73 -21.85,-8.8 -33.8,-18.18l-37.14 48.06c30.32,23.87 58.32,31.83 81.03,32.45 12.49,0.35 23.79,-1.81 32.85,-4.58 25.98,-7.88 49.26,-25.68 69.08,-52.36 1.16,-1.19 2.11,-2.43 2.97,-3.78 2.11,-2.83 4.32,-5.98 6.31,-9.36 1.68,-2.45 3.27,-4.93 4.78,-7.9 1.97,-3.88 4.21,-7.39 5.8,-11.38 0.86,-1.13 1.43,-2.4 2.13,-3.94 0.51,-1.51 1.56,-3.51 2.43,-5.31l2.69 -7.42 11.63 -26.76 170.07 -404.1 -73.32 0z"
      />
      <path
        class="fil1 str1"
        d="M7395.22 18748.72l-150.32 0 0 216.2 -70.73 0 0 -542.1 221.05 0c88.58,0 169.89,65.01 169.89,163.38 0,96.68 -79.66,162.52 -169.89,162.52zm0 -263.35l0 0 -150.32 0 0 201.58 150.32 -0.81c46.32,0.81 96.7,-42.27 96.7,-99.94 0,-56.91 -50.38,-100.83 -96.7,-100.83z"
      />
      <path
        class="fil1 str1"
        d="M7779.19 18975.46c-115.39,0 -199.12,-92.65 -199.12,-207.24 0,-113.75 83.73,-207.21 199.12,-207.21 116.18,0 199.07,93.46 199.07,207.21 0,114.59 -82.89,207.24 -199.07,207.24zm0 -360.05l0 0c-80.46,0 -131.66,68.27 -131.66,152.81 0,84.54 51.2,153.59 131.66,153.59 81.24,0 131.63,-68.27 131.63,-153.59 0,-84.54 -50.39,-152.81 -131.63,-152.81z"
      />
      <polygon class="fil1 str1" points="8042.18,18964.91 8041.34,18422.84 8106.37,18422.84 8107.18,18964.91 " />
      <path
        class="fil1 str1"
        d="M8749.45 18975.46c-115.4,0 -199.13,-92.66 -199.13,-207.24 0,-113.75 83.73,-207.22 199.13,-207.22 48.77,0 96.72,8.12 154.39,67.44l-43.05 42.24c-36.57,-40.65 -69.08,-55.27 -111.34,-55.27 -80.47,0 -131.66,68.27 -131.66,152.81 0,84.53 51.19,153.61 131.66,153.61 42.26,0 74.77,-15.45 111.34,-56.91l43.05 43.08c-57.67,58.56 -105.62,67.46 -154.39,67.46z"
      />
      <path
        class="fil1 str1"
        d="M9129.37 18975.46c-115.4,0 -199.12,-92.65 -199.12,-207.24 0,-113.75 83.72,-207.21 199.12,-207.21 116.23,0 199.07,93.46 199.07,207.21 0,114.59 -82.84,207.24 -199.07,207.24zm0 -360.05l0 0c-80.46,0 -131.66,68.27 -131.66,152.81 0,84.54 51.2,153.59 131.66,153.59 81.27,0 131.66,-68.27 131.66,-153.59 0,-84.54 -50.39,-152.81 -131.66,-152.81z"
      />
      <path
        class="fil1 str1"
        d="M9859.15 18964.91l0 -256.01c0,-63.42 -25.97,-93.49 -74.77,-93.49 -41.43,0 -73.13,32.53 -94.25,58.53l0 290.97 -65.03 0 0 -256.01c0,-63.42 -26.82,-93.49 -74.75,-93.49 -42.24,0 -73.15,32.53 -95.08,58.53l0 290.97 -65.06 0 0 -392.55 65.06 0 0 48.76c17.83,-21.93 50.36,-60.12 113.78,-60.12 56.88,0 93.43,26 109.73,73.91 23.52,-33.31 60.9,-73.91 125.13,-73.91 79.63,0 120.28,53.57 120.28,147.9l0 256.01 -65.04 0z"
      />
      <path
        class="fil2 str0"
        d="M6462.81 18152.63c265.35,-0.56 441.03,233.47 441.03,442 0,629.88 -882.07,582.53 -882.07,0 0,-237.63 175.67,-441.44 441.04,-442zm26.26 75.88c214.62,-5.73 370.37,173.09 361.42,324.63 -27.16,460.42 -716.42,389.09 -710.25,0 2.16,-136.32 134.2,-318.9 348.83,-324.63z"
      />
      <path
        class="fil2 str0"
        d="M6149.75 18989.99c219.59,0.45 364.96,-187.99 364.96,-355.88 0,-507.15 -729.92,-469.03 -729.92,0 0,191.32 145.37,355.42 364.96,355.88zm29.32 -38.43c168.1,4.97 273.21,-175.85 273.21,-281.84 0.01,-403.08 -554.29,-389.01 -546.42,0 2.39,118.33 105.11,276.87 273.21,281.84z"
      />
      <path
        class="fil2 str0"
        d="M6401.77 18413.89c242.98,-0.51 403.85,213.8 403.85,404.74 0,576.78 -807.71,533.42 -807.71,0 0,-217.59 160.87,-404.22 403.86,-404.74zm15.31 69.49c196.53,-5.24 331.08,158.74 319.42,297.27 -34.38,408.41 -648.03,410.29 -638.84,0 2.8,-124.81 122.89,-292.02 319.42,-297.27z"
      />
    </g>
    <rect class="fil0 str0" x="4513.71" y="16847.53" width="6814.26" height="814.63" />

    <g id="L_x0020_BUTTON">
      <g id="L1">
        <line class="fil0 str0" x1="4512.04" y1="3178.19" x2="1936.25" y2="3178.19" />
        <rect class="fil2 str0" x="1019.14" y="2953.51" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn active"
          x="1041.81"
          y="2953.51"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 0)"
        />
        <rect class="fil2 str0" x="1610.17" y="3090.4" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L2">
        <line class="fil0 str0" x1="4512.04" y1="3878.65" x2="3150.12" y2="3878.65" />
        <rect class="fil2 str0" x="2222.59" y="3653.98" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="2245.26"
          y="3653.98"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 1)"
        />
        <rect class="fil2 str0" x="2813.62" y="3790.86" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L3">
        <line class="fil0 str0" x1="4512.04" y1="4579.2" x2="1936.25" y2="4579.2" />
        <rect class="fil2 str0" x="1019.14" y="4354.53" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="1041.81"
          y="4354.53"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 2)"
        />
        <rect class="fil2 str0" x="1610.17" y="4491.41" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L4">
        <line class="fil0 str0" x1="4512.04" y1="5279.66" x2="3150.12" y2="5279.66" />
        <rect class="fil2 str0" x="2222.59" y="5054.99" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="2245.26"
          y="5054.99"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 3)"
        />
        <rect class="fil2 str0" x="2813.62" y="5191.88" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L5">
        <line class="fil0 str0" x1="4512.04" y1="5980.21" x2="1936.25" y2="5980.21" />
        <rect class="fil2 str0" x="1019.14" y="5755.53" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="1041.81"
          y="5755.53"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 4)"
        />
        <rect class="fil2 str0" x="1610.17" y="5892.41" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L6">
        <line class="fil0 str0" x1="4512.04" y1="6680.67" x2="3150.12" y2="6680.67" />
        <rect class="fil2 str0" x="2222.59" y="6455.99" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="2245.26"
          y="6455.99"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 5)"
        />
        <rect class="fil2 str0" x="2813.62" y="6592.88" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L7">
        <line class="fil0 str0" x1="4512.04" y1="7381.22" x2="1936.25" y2="7381.22" />
        <rect class="fil2 str0" x="1019.14" y="7156.54" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="1041.81"
          y="7156.54"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 6)"
        />
        <rect class="fil2 str0" x="1610.17" y="7293.42" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L8">
        <line class="fil0 str0" x1="4512.04" y1="8081.68" x2="3150.12" y2="8081.68" />
        <rect class="fil2 str0" x="2222.59" y="7857" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="2245.26"
          y="7857"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 7)"
        />
        <rect class="fil2 str0" x="2813.62" y="7993.89" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L9">
        <line class="fil0 str0" x1="4512.04" y1="8777.98" x2="1936.25" y2="8777.98" />
        <rect class="fil2 str0" x="1019.14" y="8553.31" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="1041.81"
          y="8553.31"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 8)"
        />
        <rect class="fil2 str0" x="1610.17" y="8690.2" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L10">
        <line class="fil0 str0" x1="4512.04" y1="9482.69" x2="3150.12" y2="9482.69" />
        <rect class="fil2 str0" x="2222.59" y="9258.02" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="2245.26"
          y="9258.02"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 9)"
        />
        <rect class="fil2 str0" x="2813.62" y="9394.9" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L11">
        <line class="fil0 str0" x1="4512.04" y1="10183.23" x2="1936.25" y2="10183.23" />
        <rect class="fil2 str0" x="1019.14" y="9958.56" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="1041.81"
          y="9958.56"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 10)"
        />
        <rect class="fil2 str0" x="1610.17" y="10095.45" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L12">
        <line class="fil0 str0" x1="4512.04" y1="10883.7" x2="3150.12" y2="10883.7" />
        <rect class="fil2 str0" x="2222.59" y="10659.03" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="2245.26"
          y="10659.03"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 11)"
        />
        <rect class="fil2 str0" x="2813.62" y="10795.91" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L13">
        <line class="fil0 str0" x1="4512.04" y1="11584.24" x2="1936.25" y2="11584.24" />
        <rect class="fil2 str0" x="1019.14" y="11359.56" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="1041.81"
          y="11359.56"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 12)"
        />
        <rect class="fil2 str0" x="1610.17" y="11496.45" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L14">
        <line class="fil0 str0" x1="4512.04" y1="12284.71" x2="3150.12" y2="12284.71" />
        <rect class="fil2 str0" x="2222.59" y="12060.03" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="2245.26"
          y="12060.03"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 13)"
        />
        <rect class="fil2 str0" x="2813.62" y="12196.91" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L15">
        <line class="fil0 str0" x1="4512.04" y1="12985.25" x2="1936.25" y2="12985.25" />
        <rect class="fil2 str0" x="1019.14" y="12760.58" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="1041.81"
          y="12760.58"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 14)"
        />
        <rect class="fil2 str0" x="1610.17" y="12897.46" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L16">
        <line class="fil0 str0" x1="4512.04" y1="13685.72" x2="3150.12" y2="13685.72" />
        <rect class="fil2 str0" x="2222.59" y="13461.04" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="2245.26"
          y="13461.04"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 15)"
        />
        <rect class="fil2 str0" x="2813.62" y="13597.92" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L17">
        <line class="fil0 str0" x1="4512.04" y1="14380.58" x2="1936.25" y2="14380.58" />
        <rect class="fil2 str0" x="1019.14" y="14155.9" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="1041.81"
          y="14155.9"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 16)"
        />
        <rect class="fil2 str0" x="1610.17" y="14292.78" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L18">
        <line class="fil0 str0" x1="4512.04" y1="15081.04" x2="3150.12" y2="15081.04" />
        <rect class="fil2 str0" x="2222.59" y="14856.36" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="2245.26"
          y="14856.36"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 17)"
        />
        <rect class="fil2 str0" x="2813.62" y="14993.25" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L19">
        <line class="fil0 str0" x1="4512.04" y1="15781.59" x2="1936.25" y2="15781.59" />
        <rect class="fil2 str0" x="1019.14" y="15556.91" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="1041.81"
          y="15556.91"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 18)"
        />
        <rect class="fil2 str0" x="1610.17" y="15693.8" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="L20">
        <line class="fil0 str0" x1="4512.04" y1="16482.05" x2="3150.12" y2="16482.05" />
        <rect class="fil2 str0" x="2222.59" y="16257.38" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="2245.26"
          y="16257.38"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 19)"
        />
        <rect class="fil2 str0" x="2813.62" y="16394.26" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
    </g>

    <g id="R_x0020_BUTTON">
      <g id="R1">
        <line class="fil0 str0" x1="11316.28" y1="3178.19" x2="13892.07" y2="3178.19" />
        <rect class="fil2 str0" x="13885.51" y="2953.51" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="13885.51"
          y="2953.51"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 20)"
        />
        <rect class="fil2 str0" x="13886.01" y="3090.4" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R2">
        <line class="fil0 str0" x1="11316.28" y1="3878.65" x2="12678.2" y2="3878.65" />
        <rect class="fil2 str0" x="12682.06" y="3653.98" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="12682.06"
          y="3653.98"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 21)"
        />
        <rect class="fil2 str0" x="12682.56" y="3790.86" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R3">
        <line class="fil0 str0" x1="11316.28" y1="4579.2" x2="13892.07" y2="4579.2" />
        <rect class="fil2 str0" x="13885.51" y="4354.53" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="13885.51"
          y="4354.53"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 22)"
        />
        <rect class="fil2 str0" x="13886.01" y="4491.41" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R4">
        <line class="fil0 str0" x1="11316.28" y1="5279.66" x2="12678.2" y2="5279.66" />
        <rect class="fil2 str0" x="12682.06" y="5054.99" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="12682.06"
          y="5054.99"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 23)"
        />
        <rect class="fil2 str0" x="12682.56" y="5191.88" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R5">
        <line class="fil0 str0" x1="11316.28" y1="5980.21" x2="13892.07" y2="5980.21" />
        <line class="fil0 str0" x1="11316.28" y1="5980.17" x2="12678.2" y2="5980.17" />
        <rect class="fil2 str0" x="13885.51" y="5755.53" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="13885.51"
          y="5755.53"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 24)"
        />
        <rect class="fil2 str0" x="13886.01" y="5892.41" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R6">
        <line class="fil0 str0" x1="11316.28" y1="6680.67" x2="12678.2" y2="6680.67" />
        <rect class="fil2 str0" x="12682.06" y="6455.99" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="12682.06"
          y="6455.99"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 25)"
        />
        <rect class="fil2 str0" x="12682.56" y="6592.88" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R7">
        <line class="fil0 str0" x1="11316.28" y1="7381.22" x2="13892.07" y2="7381.22" />
        <rect class="fil2 str0" x="13885.51" y="7156.54" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="13885.51"
          y="7156.54"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 26)"
        />
        <rect class="fil2 str0" x="13886.01" y="7293.42" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R8">
        <line class="fil0 str0" x1="11316.28" y1="8081.68" x2="12678.2" y2="8081.68" />
        <rect class="fil2 str0" x="12682.06" y="7857" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="12682.06"
          y="7857"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 27)"
        />
        <rect class="fil2 str0" x="12682.56" y="7993.89" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R9">
        <line class="fil0 str0" x1="11316.28" y1="8782.22" x2="13892.07" y2="8782.22" />
        <line class="fil0 str0" x1="11316.28" y1="8782.19" x2="12678.2" y2="8782.19" />
        <rect class="fil2 str0" x="13885.51" y="8557.55" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect class="fil2 str0" x="13885.51" y="8557.55" width="901" height="416.98" rx="200" ry="204.61" />
        <rect class="fil2 str0" x="13886.01" y="8694.44" width="332.14" height="143.23" rx="73.73" ry="70.28" />
        <rect class="fil2 str0" x="13885.51" y="8557.55" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="13885.51"
          y="8557.55"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 28)"
        />
        <rect class="fil2 str0" x="13886.01" y="8694.44" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R10">
        <line class="fil0 str0" x1="11316.28" y1="9482.69" x2="12678.2" y2="9482.69" />
        <rect class="fil2 str0" x="12682.06" y="9258.02" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="12682.06"
          y="9258.02"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 29)"
        />
        <rect class="fil2 str0" x="12682.56" y="9394.9" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R11">
        <line class="fil0 str0" x1="11316.28" y1="10183.23" x2="13892.07" y2="10183.23" />
        <rect class="fil2 str0" x="13885.51" y="9958.56" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="13885.51"
          y="9958.56"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 30)"
        />
        <rect class="fil2 str0" x="13886.01" y="10095.45" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R12">
        <line class="fil0 str0" x1="11316.28" y1="10883.7" x2="12678.2" y2="10883.7" />
        <rect class="fil2 str0" x="12682.06" y="10659.03" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="12682.06"
          y="10659.03"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 31)"
        />
        <rect class="fil2 str0" x="12682.56" y="10795.91" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R13">
        <line class="fil0 str0" x1="11316.28" y1="11584.24" x2="13892.07" y2="11584.24" />
        <rect class="fil2 str0" x="13885.51" y="11359.56" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="13885.51"
          y="11359.56"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 32)"
        />
        <rect class="fil2 str0" x="13886.01" y="11496.45" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R14">
        <line class="fil0 str0" x1="11316.28" y1="12284.71" x2="12678.2" y2="12284.71" />
        <rect class="fil2 str0" x="12682.06" y="12060.03" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="12682.06"
          y="12060.03"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 33)"
        />
        <rect class="fil2 str0" x="12682.56" y="12196.91" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R15">
        <line class="fil0 str0" x1="11316.28" y1="12985.25" x2="13892.07" y2="12985.25" />
        <rect class="fil2 str0" x="13885.51" y="12760.58" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="13885.51"
          y="12760.58"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 34)"
        />
        <rect class="fil2 str0" x="13886.01" y="12897.46" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R16">
        <line class="fil0 str0" x1="11316.28" y1="13685.72" x2="12678.2" y2="13685.72" />
        <rect class="fil2 str0" x="12682.06" y="13461.04" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="12682.06"
          y="13461.04"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 35)"
        />
        <rect class="fil2 str0" x="12682.56" y="13597.92" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R17">
        <line class="fil0 str0" x1="11316.28" y1="14380.58" x2="13892.07" y2="14380.58" />
        <rect class="fil2 str0" x="13885.51" y="14155.9" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="13885.51"
          y="14155.9"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 36)"
        />
        <rect class="fil2 str0" x="13886.01" y="14292.78" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R18">
        <line class="fil0 str0" x1="11316.28" y1="15081.04" x2="12678.2" y2="15081.04" />
        <rect class="fil2 str0" x="12682.06" y="14856.36" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="12682.06"
          y="14856.36"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 37)"
        />
        <rect class="fil2 str0" x="12682.56" y="14993.25" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R19">
        <line class="fil0 str0" x1="11316.28" y1="15781.59" x2="13892.07" y2="15781.59" />
        <rect class="fil2 str0" x="13885.51" y="15556.91" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="13885.51"
          y="15556.91"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 38)"
        />
        <rect class="fil2 str0" x="13886.01" y="15693.8" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
      <g id="R20">
        <line class="fil0 str0" x1="11316.28" y1="16482.05" x2="12678.2" y2="16482.05" />
        <rect class="fil2 str0" x="12682.06" y="16257.38" width="923.67" height="449.33" rx="205.03" ry="220.48" />
        <rect
          #lineKeyButton
          class="fil2 str0 clickable-btn"
          x="12682.06"
          y="16257.38"
          width="901"
          height="416.98"
          rx="200"
          ry="204.61"
          (click)="base.onActiveButtonToggle($event, 39)"
        />
        <rect class="fil2 str0" x="12682.56" y="16394.26" width="332.14" height="143.23" rx="73.73" ry="70.28" />
      </g>
    </g>

    <g id="L_x0020_Name">
      <g id="L1_x0020_Name">
        <rect id="_1_118" class="fil6" x="4513.71" y="2621.81" width="3400" height="711.29" />
        <text x="4776.39" y="3083.82" class="fil4 fnt0">{{ base.getLabel(0, 12) }}</text>
      </g>
      <g id="L2_x0020_name">
        <rect id="_2_117" class="fil5" x="4513.71" y="3333.1" width="3400" height="711.29" />
        <text x="4776.39" y="3795.1" class="fil4 fnt0">{{ base.getLabel(1, 12) }}</text>
      </g>
      <g id="L3_x0020_name">
        <rect id="_3_116" class="fil6" x="4513.71" y="4044.38" width="3400" height="711.29" />
        <text x="4776.39" y="4506.39" class="fil4 fnt0">{{ base.getLabel(2, 12) }}</text>
      </g>
      <g id="L4_x0020_name">
        <rect id="_4_115" class="fil5" x="4513.71" y="4755.67" width="3400" height="711.29" />
        <text x="4776.39" y="5217.67" class="fil4 fnt0">{{ base.getLabel(3, 12) }}</text>
      </g>
      <g id="L5_x0020_name">
        <rect id="_5_114" class="fil6" x="4513.71" y="5466.95" width="3400" height="711.29" />
        <text x="4776.39" y="5928.96" class="fil4 fnt0">{{ base.getLabel(4, 12) }}</text>
      </g>
      <g id="L6_x0020_name">
        <rect id="_6_113" class="fil5" x="4513.71" y="6178.24" width="3400" height="711.29" />
        <text x="4776.39" y="6640.25" class="fil4 fnt0">{{ base.getLabel(5, 12) }}</text>
      </g>
      <g id="L7_x0020_name">
        <rect id="_7_112" class="fil6" x="4513.71" y="6889.53" width="3400" height="711.29" />
        <text x="4776.39" y="7351.53" class="fil4 fnt0">{{ base.getLabel(6, 12) }}</text>
      </g>
      <g id="L8_x0020_name">
        <rect id="_8_111" class="fil5" x="4513.71" y="7600.81" width="3400" height="711.29" />
        <text x="4776.39" y="8062.82" class="fil4 fnt0">{{ base.getLabel(7, 12) }}</text>
      </g>
      <g id="L9_x0020_name">
        <rect id="_9_110" class="fil6" x="4513.71" y="8312.1" width="3400" height="711.29" />
        <text x="4776.39" y="8774.1" class="fil4 fnt0">{{ base.getLabel(8, 12) }}</text>
      </g>
      <g id="L10_x0020_name">
        <rect id="_10_109" class="fil5" x="4513.71" y="9023.38" width="3400" height="711.29" />
        <text x="4776.39" y="9485.39" class="fil4 fnt0">{{ base.getLabel(9, 12) }}</text>
      </g>
      <g id="L11_x0020_name">
        <rect id="_11_108" class="fil6" x="4513.71" y="9734.67" width="3400" height="711.29" />
        <text x="4776.39" y="10196.67" class="fil4 fnt0">{{ base.getLabel(10, 12) }}</text>
      </g>
      <g id="L12_x0020_name">
        <rect id="_12_107" class="fil5" x="4513.71" y="10445.95" width="3400" height="711.29" />
        <text x="4776.39" y="10907.97" class="fil4 fnt0">{{ base.getLabel(11, 12) }}</text>
      </g>
      <g id="L13_x0020_name">
        <rect id="_13_106" class="fil6" x="4513.71" y="11157.24" width="3400" height="711.29" />
        <text x="4776.39" y="11619.25" class="fil4 fnt0">{{ base.getLabel(12, 12) }}</text>
      </g>
      <g id="L14_x0020_name">
        <rect id="_14_105" class="fil5" x="4513.71" y="11868.53" width="3400" height="711.29" />
        <text x="4776.39" y="12330.54" class="fil4 fnt0">{{ base.getLabel(13, 12) }}</text>
      </g>
      <g id="L15_x0020_name">
        <rect id="_15_104" class="fil6" x="4513.71" y="12579.81" width="3400" height="711.29" />
        <text x="4776.39" y="13041.82" class="fil4 fnt0">{{ base.getLabel(14, 12) }}</text>
      </g>
      <g id="L16_x0020_name">
        <rect id="_16_103" class="fil5" x="4513.71" y="13291.1" width="3400" height="711.29" />
        <text x="4776.39" y="13753.11" class="fil4 fnt0">{{ base.getLabel(15, 12) }}</text>
      </g>
      <g id="L17_x0020_name">
        <rect id="_17_102" class="fil6" x="4513.71" y="14002.38" width="3400" height="711.29" />
        <text x="4776.39" y="14464.39" class="fil4 fnt0">{{ base.getLabel(16, 12) }}</text>
      </g>
      <g id="L18_x0020_name">
        <rect id="_18_101" class="fil5" x="4513.71" y="14713.67" width="3400" height="711.29" />
        <text x="4776.39" y="15175.68" class="fil4 fnt0">{{ base.getLabel(17, 12) }}</text>
      </g>
      <g id="L19_x0020_name">
        <rect id="_19_100" class="fil6" x="4513.71" y="15424.96" width="3400" height="711.29" />
        <text x="4776.39" y="15886.97" class="fil4 fnt0">{{ base.getLabel(18, 12) }}</text>
      </g>
      <g id="L20_x0020_name">
        <rect id="_20_99" class="fil7" x="4513.71" y="16136.24" width="3400" height="711.29" />
        <text x="4776.39" y="16598.24" class="fil4 fnt0">{{ base.getLabel(19, 12) }}</text>
      </g>
    </g>

    <g id="R_x0020_Name">
      <g id="R1_x0020_name">
        <rect id="_1" class="fil5" x="7913.71" y="2621.81" width="3400" height="711.29" />
        <text x="8682.8" y="3083.82" class="fil4 fnt0">{{ base.getLabel(20, 12) }}</text>
      </g>
      <g id="R2_x0020_name">
        <rect id="_2" class="fil6" x="7913.71" y="3333.1" width="3400" height="711.29" />
        <text x="8780.89" y="3795.1" class="fil4 fnt0">{{ base.getLabel(21, 12) }}</text>
      </g>
      <g id="R3_x0020_name">
        <rect id="_3" class="fil5" x="7913.71" y="4044.38" width="3400" height="711.29" />
        <text x="8781.84" y="4506.39" class="fil4 fnt0">{{ base.getLabel(22, 12) }}</text>
      </g>
      <g id="R4_x0020_name">
        <rect id="_4" class="fil6" x="7913.71" y="4755.67" width="3400" height="711.29" />
        <text x="8774.53" y="5217.67" class="fil4 fnt0">{{ base.getLabel(23, 12) }}</text>
      </g>
      <g id="R5_x0020_name">
        <rect id="_5" class="fil5" x="7913.71" y="5466.95" width="3400" height="711.29" />
        <text x="8782.8" y="5928.96" class="fil4 fnt0">{{ base.getLabel(24, 12) }}</text>
      </g>
      <g id="R6_x0020_name">
        <rect id="_6" class="fil6" x="7913.71" y="6178.24" width="3400" height="711.29" />
        <text x="8777.71" y="6640.25" class="fil4 fnt0">{{ base.getLabel(25, 12) }}</text>
      </g>
      <g id="R7_x0020_name">
        <rect id="_7" class="fil5" x="7913.71" y="6889.53" width="3400" height="711.29" />
        <text x="8780.89" y="7351.53" class="fil4 fnt0">{{ base.getLabel(26, 12) }}</text>
      </g>
      <g id="R8_x0020_name">
        <rect id="_8" class="fil6" x="7913.71" y="7600.81" width="3400" height="711.29" />
        <text x="8777.71" y="8062.82" class="fil4 fnt0">{{ base.getLabel(27, 12) }}</text>
      </g>
      <g id="R9_x0020_name">
        <rect id="_9" class="fil5" x="7913.71" y="8312.1" width="3400" height="711.29" />
        <text x="8780.57" y="8774.1" class="fil4 fnt0">{{ base.getLabel(28, 12) }}</text>
      </g>
      <g id="R10_x0020_name">
        <rect id="_10" class="fil6" x="7913.71" y="9023.38" width="3400" height="711.29" />
        <text x="8615.58" y="9485.39" class="fil4 fnt0">{{ base.getLabel(29, 12) }}</text>
      </g>
      <g id="R11_x0020_name">
        <rect id="_11" class="fil5" x="7913.71" y="9734.67" width="3400" height="711.29" />
        <text x="8621.63" y="10196.67" class="fil4 fnt0">{{ base.getLabel(30, 12) }}</text>
      </g>
      <g id="R12_x0020_name">
        <rect id="_12" class="fil6" x="7913.71" y="10445.95" width="3400" height="711.29" />
        <text x="8619.72" y="10907.97" class="fil4 fnt0">{{ base.getLabel(31, 12) }}</text>
      </g>
      <g id="R13_x0020_name">
        <rect id="_13" class="fil5" x="7913.71" y="11157.24" width="3400" height="711.29" />
        <text x="8620.67" y="11619.25" class="fil4 fnt0">{{ base.getLabel(32, 12) }}</text>
      </g>
      <g id="R14_x0020_name">
        <rect id="_14" class="fil6" x="7913.71" y="11868.53" width="3400" height="711.29" />
        <text x="8613.36" y="12330.54" class="fil4 fnt0">{{ base.getLabel(33, 12) }}</text>
      </g>
      <g id="R15_x0020_name">
        <rect id="_15" class="fil5" x="7913.71" y="12579.81" width="3400" height="711.29" />
        <text x="8621.63" y="13041.82" class="fil4 fnt0">{{ base.getLabel(34, 12) }}</text>
      </g>
      <g id="R16_x0020_name">
        <rect id="_16" class="fil6" x="7913.71" y="13291.1" width="3400" height="711.29" />
        <text x="8616.54" y="13753.11" class="fil4 fnt0">{{ base.getLabel(35, 12) }}</text>
      </g>
      <g id="R17_x0020_name">
        <rect id="_17" class="fil5" x="7913.71" y="14002.38" width="3400" height="711.29" />
        <text x="8619.72" y="14464.39" class="fil4 fnt0">{{ base.getLabel(36, 12) }}</text>
      </g>
      <g id="R18_x0020_name">
        <rect id="_18" class="fil6" x="7913.71" y="14713.67" width="3400" height="711.29" />
        <text x="8616.54" y="15175.68" class="fil4 fnt0">{{ base.getLabel(37, 12) }}</text>
      </g>
      <g id="R19_x0020_name">
        <rect id="_19" class="fil5" x="7913.71" y="15424.96" width="3400" height="711.29" />
        <text x="8619.4" y="15886.97" class="fil4 fnt0">{{ base.getLabel(38, 12) }}</text>
      </g>
      <g id="R20_x0020_name">
        <rect id="_20" class="fil3" x="7913.71" y="16136.24" width="3400" height="711.29" />
        <text x="8615.58" y="16598.24" class="fil4 fnt0">{{ base.getLabel(39, 12) }}</text>
      </g>
    </g>
  </g>
</svg>
